export const stringToAmount = (amount: number) => {
  const ans = `Rs.${amount}`
  return ans
}
